// app/shared/components/dieuhanh/phanbo-chiphiedit.component.ts
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Repository } from '../../../services/repository';

const swal = require('sweetalert');
@Component({
  selector: 'app-phanbo-chiphiedit',
  templateUrl: './phanbo-chiphiedit.component.html',
  styleUrls: ['./phanbo-chiphiedit.component.scss']
})
export class PhanBoChiPhiEditComponent implements OnInit {
  @Output() save = new EventEmitter<any>();

  public chungTuId: string = null;
  public soTienGoc: number = 0;
  public tuThang: Date = new Date();
  public denThang: Date = new Date();
  public danhSachPhanBo: any[] = [];
  public isProcessed: boolean = false;
  public currentUser: any;
  public ghiChu: string = '';

  constructor(private repo: Repository) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  ngOnInit() { }

  loadDataInit(chungTuId: string, soTien: number): void {
    this.chungTuId = chungTuId;
    this.soTienGoc = soTien;
    this.tuThang = new Date();
    this.denThang = new Date();
    this.denThang.setMonth(this.denThang.getMonth() + 1); // Default to 1 month
    this.danhSachPhanBo = [];
    this.isProcessed = false;
    this.ghiChu = '';

    // Load existing allocations if any
    this.loadExistingAllocations();
  }
  getTongTien(): number {
    return this.danhSachPhanBo.reduce((total, item) => total + item.SoTien, 0);
  }
  private loadExistingAllocations(): void {
    if (!this.chungTuId) return;

    this.repo.postRequest('api/quanlythuchi/get_phanbo/', { IdGuid: this.chungTuId })
      .subscribe(
        response => {
          if (response && response.length > 0) {
            this.danhSachPhanBo = response;
            this.isProcessed = true;
          }
        },
        error => console.error('Error loading allocations:', error)
      );
  }

  phanBoChiPhi(): void {
    // Validate inputs
    if (this.denThang < this.tuThang) {
      swal('Cảnh báo!', 'Thời gian đến phải lớn hơn hoặc bằng thời gian từ.', 'warning');
      return;
    }

    // Calculate month difference
    const tuThangDate = new Date(this.tuThang);
    const denThangDate = new Date(this.denThang);
    const months = this.monthDiff(tuThangDate, denThangDate) + 1; // Add 1 to include both start and end months

    if (months <= 0) {
      swal('Cảnh báo!', 'Thời gian phân bổ không hợp lệ.', 'warning');
      return;
    }

    // Calculate allocation amount per month
    const soTienPhanBo = Math.round((this.soTienGoc / months) * 100) / 100; // Round to 2 decimals

    this.danhSachPhanBo = [];

    // Generate allocations for each month
    for (let i = 0; i < months; i++) {
      const ngayPhanBo = new Date(tuThangDate);
      ngayPhanBo.setMonth(tuThangDate.getMonth() + i);

      // Set to last day of month
      const lastDay = new Date(ngayPhanBo.getFullYear(), ngayPhanBo.getMonth() + 1, 0);

      // For the last month, adjust to ensure total adds up exactly
      const soTien = i === months - 1
        ? this.soTienGoc - (soTienPhanBo * (months - 1))
        : soTienPhanBo;

      this.danhSachPhanBo.push({
        Id: null,
        ChungTuId: this.chungTuId,
        Ngay: lastDay,
        SoTien: soTien,
        GhiChu: this.ghiChu,
        Created: new Date(),
        CreatedBy: this.currentUser.user_name,
        Modified: new Date(),
        ModifiedBy: this.currentUser.user_name
      });
    }

    this.isProcessed = true;
  }

  private monthDiff(d1: Date, d2: Date): number {
    let months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months;
  }

  luuPhanBo(): void {
    if (!this.danhSachPhanBo || this.danhSachPhanBo.length === 0) {
      swal('Cảnh báo!', 'Chưa có dữ liệu phân bổ để lưu.', 'warning');
      return;
    }

    const data = {
      ChungTuId: this.chungTuId,
      DanhSachPhanBo: this.danhSachPhanBo,
      UserName: this.currentUser.user_name
    };

    this.repo.postRequest('api/quanlythuchi/save_phanbo/', data)
      .subscribe(
        response => {
          if (response === 'OK') {
            swal('Thành công!', 'Dữ liệu phân bổ đã được lưu.', 'success');
            this.save.emit(true);
          } else {
            swal('Lỗi!', response, 'error');
          }
        },
        error => {
          console.error('Error saving allocations:', error);
          swal('Lỗi!', 'Có lỗi xảy ra khi lưu dữ liệu phân bổ.', 'error');
        }
      );
  }
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };
  // Add these methods to your component class

  /**
   * Handles amount changes and updates the validation state
   */
  onAmountChange(): void {
    // You can add additional logic here if needed
    // The method is called whenever an amount is changed
  }

  /**
   * Checks if the total allocated amount matches the original amount
   * @returns boolean indicating if the amounts are balanced
   */
  isAmountBalanced(): boolean {
    const difference = Math.abs(this.getTongTien() - this.soTienGoc);
    // Allow for a small rounding error (0.01)
    return difference <= 0.01;
  }

  /**
   * Gets the difference between the total allocated amount and the original amount
   * @returns The difference amount
   */
  getDifference(): number {
    return this.getTongTien() - this.soTienGoc;
  }

  /**
   * Validates if the allocation is valid for saving
   * @returns boolean indicating if the allocation is valid
   */
  isValid(): boolean {
    // Check if all amounts are valid and the total matches the original amount
    return this.isAmountBalanced() &&
      this.danhSachPhanBo.every(item => item.SoTien >= 0);
  }
}
